import { Logo } from "@/components/Brand";

const HERO = "https://images.unsplash.com/photo-1724582586458-a51791349977?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex bg-white font-sans">
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          <div className="mb-10"><Logo className="h-11" /></div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="mt-2 text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
      <div className="hidden lg:block flex-1 relative">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/20" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="font-serif-display text-3xl leading-snug drop-shadow">"I nostri ospiti adorano quanto sia tutto semplice adesso."</p>
        </div>
      </div>
    </div>
  );
}

export const inputCls =
  "w-full rounded-xl border border-slate-200 px-4 py-3 text-[15px] outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-shadow";
export const btnCls =
  "w-full rounded-xl bg-blue-500 text-white font-semibold py-3 hover:bg-blue-600 disabled:opacity-60 transition-colors";
